import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from 'app/directives/directives.module';
import {
    FcpAlertModule,
    FcpButtonModule,
    FcpCardModule,
    FcpFormFieldModule,
    FcpIconModule,
    FcpInputModule,
    FcpModalModule
} from 'fc-ui-components';
import { SharedModule } from 'shared/shared.module';
import { StoresModalComponent } from './stores-modal.component';
import { CreateStoreDialogModule } from '../../create-store/create-store-dialog.module';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FcpModalModule,
        FcpButtonModule,
        ReactiveFormsModule,
        SharedModule,
        FcpFormFieldModule,
        FcpIconModule,
        FcpInputModule,
        FcpCardModule,
        DirectivesModule,
        FcpAlertModule,
        FcpModalModule,
        CreateStoreDialogModule
    ],
    declarations: [StoresModalComponent],
    exports: [StoresModalComponent]
})
export class StoresModalModule {}
